import { render } from "./CharacterConfigurator.vue?vue&type=template&id=0700d3a4&scoped=true"
import script from "./CharacterConfigurator.vue?vue&type=script&lang=js"
export * from "./CharacterConfigurator.vue?vue&type=script&lang=js"

import "./CharacterConfigurator.vue?vue&type=style&index=0&id=0700d3a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0700d3a4"]])

export default __exports__